import { ref as a, readonly as r, watch as o } from "vue";
function l(e) {
  const t = a(!!e.value);
  if (t.value)
    return r(t);
  const u = o(e, (n) => {
    n && (t.value = !0, u());
  });
  return r(t);
}
export {
  l as default
};
